import React, { useState, useContext } from "react";
import * as styles from "./DropDown.module.scss";
import arrowWhite from "../../../icons/arrows/downArrow.svg";
import arrowBlack from "../../../icons/arrows/downArrowBlack.svg";
import arg from "../../../icons/flags/arg.svg";
import uru from "../../../icons/flags/uru.svg";
import par from "../../../icons/flags/par.svg";
import chi from "../../../icons/flags/chi.svg";
import bol from "../../../icons/flags/bol.svg";
import { AppContext } from "../../../context/AppContext";

const DropDown = ({ name, options, color, component, drop = "down" }) => {
  const [isDropDownOpen, setDropDownOpen] = useState(false);
  const [isRotated, setRotated] = useState(false);
  const { country, setCountry } = useContext(AppContext);

  const toggleDropdown = () => {
    setDropDownOpen(!isDropDownOpen);
    setRotated(!isRotated);
  };

  const flags = {
    Argentina: arg,
    Uruguay: uru,
    Paraguay: par,
    Chile: chi,
    Bolivia: bol,
  };

  const countryDomains = {
    argentina: "www.peabody.com.ar",
    uruguay: "www.peabody.com.uy",
    paraguay: "www.peabody.com.py",
    chile: "www.peabody.cl",
    bolivia: "www.peabody.com.bo",
  };

  const colorStyles = {
    black: {
      backgroundColorVar: "var(--black-background)",
      textColorVar: "var(--black-text)",
    },
    white: {
      backgroundColorVar: "var(--white-background)",
      textColorVar: "var(--white-text)",
    },
  };

  const { backgroundColorVar, textColorVar } = colorStyles[color];

  const inlineStyles = {
    "--my-background-color-var": backgroundColorVar,
    "--my-text-color-var": textColorVar,
  };

  const handleCountrySelect = (countryName) => {
    setDropDownOpen(false);
    setRotated(false);
    setCountry(countryName);
  
    const countryNameNormalized = countryName.trim().toLowerCase();
  
    const newDomain = countryDomains[countryNameNormalized];
  
    if (newDomain) {
      const newUrl = `https://${newDomain}`;
      window.location.href = newUrl;
    } else {
      console.error(`No se encontró dominio para el país: ${countryName}`);
    }
  };

  return (
    <div>
      <div className={styles.container} onClick={toggleDropdown}>
        <div style={inlineStyles} className={styles.colorTexto}>
          <div className={styles.container_country}>
            {country ? (
              <>
                <p>{country}</p>
                <img
                  src={flags[country]}
                  alt={`Bandera de ${country}`}
                />
              </>
            ) : (
              <p>{name}</p>
            )}
          </div>
        </div>
        {color === "black" ? (
          <div className={` ${isRotated ? styles.rotate : styles.rotate2}`}>
            <img src={arrowWhite} alt="Icono" />
          </div>
        ) : (
          <div className={` ${isRotated ? styles.rotate : styles.rotate2}`}>
            <img src={arrowBlack} alt="Icono" />
          </div>
        )}
      </div>

      {isDropDownOpen && (
        <div
          className={`${styles.dropdown__content} ${
            drop === "down" ? styles.margin1 : styles.margin2
          }`}
        >
          {options?.map((option) => (
            <div
              className={`${styles.container__drop} ${
                isDropDownOpen ? styles.open : null
              }`}
              key={option.name}
              onClick={() => handleCountrySelect(option.name)}
            >
              <p className={styles.texto}>{option.name.slice(0, 3)}</p>
              <img src={flags[option.name]} alt={option.name} />
            </div>
          ))}
          {component}
        </div>
      )}
    </div>
  );
};

export default DropDown;
